"use client";

import { IFormInput, IFormProps, IFormSubmit } from "@template/components/Form";
import React, { useEffect, useState } from "react";
import { Form } from "@template/components";
import TabContent from "@template/components/Tabs/TabContent";
import { TabsSectionContainer } from "@template/components/Tabs/styles.ts";
import * as S from "./styles.ts";
import axios from "axios";
import DomainNameCustomSearchResults from "@template/blocks/domain/DomainNameCustomSearchResults";
import { IDomainSearchResults } from "@/redux/slices/domains/types.ts";
import { useTypedDispatch, useTypedSelector } from "@/redux/helpers/hooks.ts";
import { getTlds } from "@/redux/slices/store/thunks/getTlds.ts";
import ArchStandaloneSectionComponent from "@template/blocks/ArchStandaloneSection/component";

type DomainNameTldSearchProps = {
  input?: Omit<IFormInput, "name">;
  submit?: Omit<IFormSubmit, "onSubmit">;
  tlds: { tld: number }[];
  availableTitle?: string;
  unavailableTitle?: string;
};

const DomainNameTldSearch = ({
                               input,
                               submit,
                               tlds,
                               availableTitle,
                               unavailableTitle,
                             }: DomainNameTldSearchProps) => {
  const dispatch = useTypedDispatch();

  const availableTlds = useTypedSelector((state) => state.store.tlds.tlds);

  const [formValue, setFormValue] = useState({
    search: "",
  });
  const [results, setResults] = useState<IDomainSearchResults | null>(null);
  const [loading, setLoading] = useState(false);

  const inputs: IFormProps["inputs"] = [
    {
      ...input,
      type: "text",
      name: "search",
      required: true,
      hiddenRequired: true,
      autoFocus: true,
    },
  ];

  const handleChange = (vals: any) => {
    setFormValue(vals);
  };

  const onSubmit = async () => {
    setLoading(true);
    const { search } = formValue;
    if (!search) return;
    setResults(null);
    await axios
      .post(`/api/domain-names/custom-search`, {
        search,
        tlds: tlds.map((tld) => tld.tld),
      })
      .then((res) => {
        if (res.data) {
          setResults(res.data);
        }
      });
    setLoading(false);
  };

  useEffect(() => {
    if (!availableTlds.loaded) {
      dispatch(getTlds());
    }
  }, [availableTlds.loaded]);

  return (
    <>
      <S.Wrapper>
        <ArchStandaloneSectionComponent
          color="white"
          background="dark"
          withPadding
        />
        <TabsSectionContainer style={{ zIndex: 1 }}>
          <TabContent>
            <Form
              value={formValue}
              onChange={handleChange}
              inputs={inputs}
              simple
              submit={{
                ...submit,
                text: submit.children,
                style: {
                  width: "fit-content",
                  marginLeft: "auto",
                },
                onSubmit,
                disabled: loading,
              }}
            />
          </TabContent>
        </TabsSectionContainer>
      </S.Wrapper>
      <DomainNameCustomSearchResults
        results={results}
        loading={loading}
        available={{
          title: availableTitle,
        }}
        unavailable={{
          title: unavailableTitle,
          button: {
            children: "What is Domain Backordering",
            size: "md",
            variant: "flat",
            href: "/domain-names/backorder/",
          },
        }}
      />
    </>
  );
};

export default DomainNameTldSearch;
